import type { CareersProcessCopy } from "../../_components/careers-content";

/** Developer hiring process for `/careers/engineering` only (English). */
export const ENGINEERING_PROCESS: CareersProcessCopy = {
  title: "What to expect in our application process",
  subtitle:
    "We know that applying takes time and energy. That's why we keep the process transparent – you'll know exactly where you stand at every step.",
  steps: [
    {
      title: "Application Review",
      body: "A few short questions in the application form help us get to know you from the start. Take a moment with your answers – either way, you'll hear back from us.",
    },
    {
      title: "Video Intro Call",
      body: "In a short video call, we get to know each other: your background, your goals, and what matters to you in your next step. You can ask us anything too – about the role, the product, or how the team works.",
    },
    {
      title: "Skills Assessment",
      body: "You'll get a hands-on task modeled on the role's actual day-to-day work – with clear goals and reasonable requirements. Plan for about a working day.",
    },
    {
      title: "Video Interview",
      body: "After the skills assessment, we go deeper: we talk about the role itself, your experience so far, and how you work. An open conversation between equals – with honest insights and room for your questions.",
    },
    {
      title: "Reference Checks",
      body: "Finally, we'll ask you for references who can speak to your professional experience – ideally at least one person you reported to. These conversations help us confirm the impression we've already formed of you in the interviews.",
    },
  ],
};
